<template>
	<div class="brand" ref="height_top" v-bind:style="{ height: tableHeight + 'px' }">
		<div class="selected">
			<el-row>
				<el-col :span="4" :offset="2">
					<div class="img">
						<div class="icon triangle-icon"></div>
						<img src="../../assets/img/c3dce36b9325f1877bd9ccf3c474f240.png" alt="">
					</div>
					<div>
						<p>ABB</p>
					</div>
				</el-col>
			</el-row>
		</div>
		<div>
			<el-row>
				<el-col :span="22" :offset="2">
					<el-row class="top_screen">
						<el-col :span="1">
							<a>
								A
							</a>
						</el-col>
						<el-col :span="1">
							<a>
								B
							</a>
						</el-col>
						<el-col :span="1">
							<a>
								C
							</a>
						</el-col>
						<el-col :span="1">
							<a>
								S
							</a>
						</el-col>
						<el-col :span="1">
							<a>
								T
							</a>
						</el-col>
					</el-row>
				</el-col>
			</el-row>
		</div>
		<div class="selected" style="padding-left:0px">
			<el-row>
				<el-col :span="1" :offset="1" class="left_screen">
					<p>
						A
					</p>
				</el-col>
				<el-col :span="4">
					<div class="img">
						<div class="icon triangle-icon"></div>
						<img src="../../assets/img/c3dce36b9325f1877bd9ccf3c474f240.png" alt="">
					</div>
					<div>
						<p>ABB</p>
					</div>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="1" :offset="1" class="left_screen">
					<p>
						B
					</p>
				</el-col>
				<el-col :span="4">
					<div class="img">
						<div class="icon triangle-icon"></div>
						<img src="../../assets/img/1a5062de49e5afeddc4acce3e20fc090.png" alt="">
					</div>
					<div>
						<p>ABB</p>
					</div>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="1" :offset="1" class="left_screen">
					<p>
						C
					</p>
				</el-col>
				<el-col :span="4">
					<div class="img">
						<div class="icon triangle-icon"></div>
						<img src="../../assets/img/ed72df6c3903a1c12d0ebd592a598fba.png" alt="">
					</div>
					<div>
						<p>ABB</p>
					</div>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="1" :offset="1" class="left_screen">
					<p>
						S
					</p>
				</el-col>
				<el-col :span="4">
					<div class="img">
						<div class="icon triangle-icon"></div>
						<img src="../../assets/img/6ca2b47f0087064439bcbfbd4d1e458c.png" alt="">
					</div>
					<div>
						<p>ABB</p>
					</div>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="1" :offset="1" class="left_screen">
					<p>
						T
					</p>
				</el-col>
				<el-col :span="4">
					<div class="img">
						<div class="icon triangle-icon"></div>
						<img src="../../assets/img/789c15a935fb79f0f8334c311c2561c9.png" alt="">
					</div>
					<div>
						<p>ABB</p>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>
<script>
export default {
	components: {},
	data() {

		return {
			tableHeight:'',

		}
	},
	props: [],

	updated() {

	},


	mounted() {

	},

	activated() {

	},
	created() {

	},
	watch: {

	},
	methods: {
		tableHeight_fun() {
			this.$nextTick(() => {
				this.tableHeight = window.innerHeight - this.$refs.height_top.getBoundingClientRect().top - 55
				console.log(this.tableHeight, 12122)
			})
		},
	}
}
</script>
<style lang="less" scoped>
</style>